import { __awaiter, __generator } from "tslib";
import { CreationError, } from '@office-start/create-types';
import { logError } from '@office-start/telemetry-service';
import { getDocAspxFormActionUrlAndToken } from '../util/getDocAspxFormActionUrlAndToken';
var newTabHtmlText = "<!doctype html>\n<html>\n<head>\n</head>\n<body>\n</body>\n</html>\n";
var docaspxFormHtmlText = "<form id=\"create-new-doc-form\" method=\"post\" action=\"APIURL\" style=\"display: none;\" target=\"_top\"><input id=\"create-new-doc-token\" name=\"access_token\" value=\"ONEDRIVETOKEN\" /></form>";
/* Calling DocAspx API for a faster create new document flow
The API works by submitting a form with the token in the POST body to the docaspx endpoint.
The endpoint then immediately returns the WAC editor HTML before actually creating the empty file in OneDrive.
This is faster since we don't need to redirect to a different URL once the API returns and we don't wait for the empty file to be created.

The inputs to the API are:
OneDrive access token;
User's doclib url. We get this from our existing call to Graph for /me/drive/root

The overall flow is similar to the existing flow:
    create a blank new tab page to avoid browser popup blocker issues
    Construct the form HTML and then write it to the new tab.
    Submit the form. This will automatically load the WAC editor once the form submit finishes.
    If for some reason, we can't open a new tab, then submit the form on the same tab.
*/
export function createDocAspx(createDocAspxParams) {
    return __awaiter(this, void 0, void 0, function () {
        var startTime, options, instrumentCallback, targetTab, _a, apiUrl, accessToken, tabDocument, formHtml, form, processTimeInMilliseconds, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    startTime = createDocAspxParams.startTime, options = createDocAspxParams.options, instrumentCallback = createDocAspxParams.instrumentCallback;
                    targetTab = options.targetTab;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getDocAspxFormActionUrlAndToken(createDocAspxParams)];
                case 2:
                    _a = _b.sent(), apiUrl = _a.apiUrl, accessToken = _a.accessToken;
                    tabDocument = void 0;
                    if (targetTab) {
                        targetTab.document.write(newTabHtmlText);
                        tabDocument = targetTab.document;
                    }
                    else {
                        tabDocument = document;
                    }
                    formHtml = docaspxFormHtmlText
                        .replace('APIURL', apiUrl)
                        .replace('ONEDRIVETOKEN', accessToken.token);
                    // eslint-disable-next-line @microsoft/sdl/no-inner-html
                    tabDocument.body.insertAdjacentHTML('beforeend', formHtml);
                    form = tabDocument.getElementById('create-new-doc-form');
                    if (form) {
                        processTimeInMilliseconds = Date.now() - startTime;
                        instrumentCallback && instrumentCallback(processTimeInMilliseconds);
                        form.submit();
                        return [2 /*return*/, Promise.resolve({
                                type: "GoToBlankDoc" /* CreateDocumentResultType.GoToBlankDoc */,
                            })];
                    }
                    else {
                        throw new CreationError('Form element not found', "Error" /* CreateDocumentResultType.Error */);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    logError({
                        eventName: 'Docaspx_Creation_Failure',
                        debugInfo: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || 'docaspx failed',
                    });
                    return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=createDocAspx.js.map